import _get from 'lodash/get';

export const ITEMS_IN_WIDGET = 5;

export const SORT_BY = {
  CREATED_AT: 'SORT_FIELD_CREATED_AT',
  VALUE: 'SORT_FIELD_VALUE',
}

export const ORDER = {
  ASC: 'asc',
  DESC: 'desc',
};

export const STATUSES = {
  UNSPECIFIED: 'TX_STATUS_UNSPECIFIED',
  NEW: 'TX_STATUS_NEW',
  PENDING: 'TX_STATUS_PENDING',
  SUCCESS: 'TX_STATUS_SUCCESS',
  FAILURE: 'TX_STATUS_FAILURE',
}

export const STATUSES_MESSAGES = {
  TX_STATUS_UNSPECIFIED: 'status.unspecified',
  TX_STATUS_NEW: 'status.new',
  TX_STATUS_PENDING: 'status.pending',
  TX_STATUS_SUCCESS: 'status.succeed',
  TX_STATUS_FAILURE: 'status.failure',
}

export const getStatusMessage = (status: string) => {
  return _get(STATUSES_MESSAGES, status, STATUSES_MESSAGES.TX_STATUS_NEW);
}

export const getStatusIconVariant = (status: string) : any => {
  let variant = 'warning';
  switch (status) {
    case STATUSES.NEW:
    case STATUSES.PENDING:
    case STATUSES.UNSPECIFIED:
      variant = 'warning';
      break;
    case STATUSES.SUCCESS:
      variant = 'success';
      break;
    case STATUSES.FAILURE:
      variant = 'danger';
      break;
  }
  return variant;
}